<template lang="pug">
  .component.component-backoffice-vehicle-slot(v-if="item")
    .asset-management-list(v-if="$is('asset-management-list')")
      .item-vehicle-slot-id VS-{{item.id}}
      .item-vehicle-slot-name {{item.name}}
      .item-vehicle-slot-name Booking mode {{item.reservation_type}}
        //inline-editable-field(:item="item.name", @fieldUpdated="edit")
    .card.inner-content(v-else)
      .name
        h3 {{ item.name }}  [disabled: {{ item.disabled }}]

      .description
        p {{ item.reservation_type }} - {{ item.vehicle.model }} - {{ item.vehicle.plate }}
        button.button.success(type="button", v-on:click="enable") Enable
        button.button.warning(type="button", v-on:click="disable") Disable
      accordion(:items="item")

</template>

<script type="text/babel">
  import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
  import MaggieHelper from "../../maggieHelper";
  import Accordion from '../../components/structure/foundation/Accordion.vue'
  import InlineEditableField from "../structure/ui/InlineEditableField";

  export default {
    name: "BackofficeVehicleSlot",
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
    components: {
      InlineEditableField,
      Accordion,
    },
    created() {
    },
    methods: {
      update: function () {
        this.$emit("updated", this.item);
      },
      enable: function () {
        KeplerBackofficeSdk.vehicleSlots.select(this.item).enable((response) => {
          this.update()
          MaggieHelper.notification('enable-esit', "vehicle slot enabled")
        })
      },
      disable: function () {
        KeplerBackofficeSdk.vehicleSlots.select(this.item).disable((response) => {
          this.update()
          MaggieHelper.notification('disable-esit', "vehicle slot disabled")
        })
      },
      edit(edited) {
      }
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// VehicleSlot.vue?30d467fc